/**
 * Applies a discount code passed in the URL (e.g. ?discount=SUMMER10) to the cart
 * through the Cart AJAX API, then removes the parameter from the URL.
 *
 * https://shopify.dev/docs/api/ajax/reference/cart#update-discounts-in-the-cart
 */
(() => {
  const PARAM_NAME = 'discount';
  const url = new URL(window.location.href);
  const code = url.searchParams.get(PARAM_NAME)?.trim();

  if (!code) {
    return;
  }

  const routesRoot = window.Shopify?.routes?.root || '/';

  const removeParamFromUrl = () => {
    url.searchParams.delete(PARAM_NAME);
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
  };

  const getCartDiscountCodes = async () => {
    const response = await fetch(`${routesRoot}cart.js`, { headers: { Accept: 'application/json' } });

    if (!response.ok) {
      return [];
    }

    const cart = await response.json();
    return (cart.discount_codes || []).map((discount) => discount.code);
  };

  const applyDiscount = async () => {
    try {
      // Setting "discount" replaces every code on the cart, so keep the ones already applied
      const existingCodes = await getCartDiscountCodes();
      const codes = existingCodes.filter((existingCode) => existingCode.toLowerCase() !== code.toLowerCase());
      codes.push(code);

      const response = await fetch(`${routesRoot}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      });

      if (!response.ok) {
        throw new Error(`Cart update failed with status ${response.status}`);
      }

      removeParamFromUrl();
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {
      console.warn(`Unable to apply discount code "${code}".`, error);
    }
  };

  applyDiscount();
})();
